"use client"

import ButtonWithArrow from "@/ui/common/bit/ButtonWithArrow"
import CommonTitle from "@/ui/common/bit/CommonTitle"
import styled from "@emotion/styled"
import { Box, Button, FormControl } from "@mui/material"
import { colors, mediaQueries, sizes } from "ui"

export const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${sizes.baseQuadric};
  ${mediaQueries.desktopM} {
    justify-content: space-between;
    gap: 40px;
  }
`

export const StyledFormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${sizes.borderRadiusLarge};
  background-color: ${colors.white};
  border-radius: ${sizes.borderRadiusLarge};
  box-shadow: ${colors.dropShadow.main};

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: ${sizes.baseDouble};
    ${mediaQueries.desktopM} {
      flex-direction: row;
      align-items: flex-start;
    }
  }

  ${mediaQueries.tabletDown} {
    margin-top: ${sizes.baseSix};
  }

  ${mediaQueries.desktopM} {
    flex-direction: row;
  }
`

export const FormFieldsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  ${mediaQueries.desktopM} {
    flex-direction: row;
    align-items: baseline;
  }
`

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  min-width: 338px;
  ul {
    flex-direction: column;
  }
  .MuiOutlinedInput-root {
    border-radius: 4px;
    background-color: ${colors.white};
    height: ${sizes.baseSepta};

    &:hover {
      border-color: ${colors.red};
    }

    &.Mui-focused {
      border-color: ${colors.red};
    }
  }

  .MuiInputLabel-root {
    color: ${colors.black};
    font-size: 16px;

    &.Mui-focused {
      color: ${colors.red};
    }
  }

  ${mediaQueries.mobile} {
    .MuiInputLabel-root {
      font-size: 14px;
    }

    .MuiSelect-select {
      font-size: 14px;
    }
  }
`

export const StyledFormTitles = styled(CommonTitle)`
  align-items: center;
  text-align: center;
  gap: ${sizes.baseDouble};
`

export const StyledButton = styled(ButtonWithArrow)`
  padding: ${sizes.baseSingle} ${sizes.baseDouble};
  align-self: center;
  ${mediaQueries.desktopM} {
    padding: 0;
    border-radius: 50%;
    min-width: unset;
    width: ${sizes.baseSepta};
    height: ${sizes.baseSepta};
    flex: 0 0 auto;
    .MuiBox-root {
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: 0;

      svg {
        width: 24px;
        height: 24px;
        stroke: ${colors.white};
        margin: 0;
        object-fit: contain;
      }
    }
    .arrow-icon {
      display: none;
    }
  }
`

export const StyledSuccessFeedback = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: ${sizes.baseDouble};
  padding: ${sizes.baseSingle};
  gap: ${sizes.baseTriple};
  border-radius: ${sizes.baseHalf};
`

export const StyledSearchResultsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledPaginationContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${sizes.baseDouble};
  gap: ${sizes.baseSingle};
`

export const StyledPaginationButton = styled(Button)<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  &.left {
    transform: rotate(180deg);
  }
  ${mediaQueries.desktopM} {
    padding: 0;
  }
`

export const StyledResultsNumber = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: ${sizes.baseDouble} 0;
  width: 100%;
  text-align: start;
  font-size: 14px;
  color: ${colors.black};
  ${mediaQueries.desktopM} {
    font-size: 16px;
  }
`

export const StyledPaginationInfo = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${sizes.baseDouble};
  font-size: 14px;
  color: ${colors.black};
  ${mediaQueries.desktopM} {
    font-size: 16px;
  }
`
